import script from "./Hue.vue?vue&type=script&lang=ts&setup=true"
export * from "./Hue.vue?vue&type=script&lang=ts&setup=true"

import "./Hue.vue?vue&type=style&index=0&id=5711e710&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5711e710"]])

export default __exports__